import { Controller } from "@hotwired/stimulus"


// Controller responsável por carregar Google Maps dinamicamente
// Elimina necessidade de JavaScript inline nas views
export default class extends Controller {
  static values = { apiKey: String }

  connect() {
    this.loadGoogleMaps()
  }

  disconnect() {
  }

  loadGoogleMaps() {
    
    if (window.google && window.google.maps) {
      setTimeout(() => this.dispatchMapsLoadedEvent(), 200)
      return
    }

    if (document.querySelector('script[src*="maps.googleapis.com"]')) {
      this.waitForMapsToLoad()
      return
    }

    const script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKeyValue}&libraries=places,geometry,marker`
    script.async = false
    script.onload = () => this.dispatchMapsLoadedEvent()
    script.onerror = () => this.handleLoadError()
    
    document.head.appendChild(script)
  }

  waitForMapsToLoad() {
    const checkInterval = setInterval(() => {
      if (window.google && window.google.maps) {
        clearInterval(checkInterval)
        this.dispatchMapsLoadedEvent()
      }
    }, 100)

    setTimeout(() => {
      clearInterval(checkInterval)
      if (!window.google || !window.google.maps) {
        this.handleLoadError()
      }
    }, 10000)
  }

  dispatchMapsLoadedEvent() {
    
    document.body.setAttribute('data-google-maps-loaded', 'true')
    document.body.setAttribute('data-google-maps-api-key', this.apiKeyValue)
    
    document.dispatchEvent(new CustomEvent('google-maps-loaded', {
      detail: { 
        apiKey: this.apiKeyValue,
        timestamp: Date.now(),
        source: 'google-maps-loader'
      }
    }))
  }

  handleLoadError() {
    document.dispatchEvent(new CustomEvent('google-maps-error', {
      detail: { 
        message: 'Falha ao carregar Google Maps',
        timestamp: Date.now()
      }
    }))
  }
}